import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  capitalize,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import FuhrparkeintragFieldsContent from "./FuhrparkeintragFieldsContent";
import DeleteFuhrparkeintragButton from "./DeleteFuhrparkeintragButton";
import React from "react";
import DeleteFuhrparkeintragNewButton from "./DeleteFuhrparkeintragNewButton";
import { ExtendedFuhrparkeintragDaten } from "../../../models/taetigkeitsberichte/models";

export default function FuhrparkeintragEigenPersonalItem({
  isNew,
  fuhrparkeintrag,
  index,
  expanded,
  handleChange,
  taetigkeitsberichtDatum,
  dauerVorhanden,
  isValidating,
  isValid,
  remove,
  taetigkeitsberichtId,
  taetigkeitsberichtBaustelleId,
}: {
  isNew: boolean;
  fuhrparkeintrag: ExtendedFuhrparkeintragDaten;
  index: number;
  expanded: boolean;
  handleChange: (index: number) => void;
  taetigkeitsberichtDatum?: string;
  dauerVorhanden: number;
  isValidating: boolean;
  isValid: boolean;
  remove: () => void;
  taetigkeitsberichtId: string;
  taetigkeitsberichtBaustelleId?: string;
}) {
  const { t } = useTranslation("taetigkeitsbericht");
  return (
    <Accordion
      key={fuhrparkeintrag.id}
      expanded={expanded}
      onChange={() => handleChange(index)}
      sx={{ width: "100%", padding: 2 }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{ position: "relative", paddingLeft: 0 }}
      >
        <Box>{capitalize(t("carpool-entry"))}</Box>
        {taetigkeitsberichtId === "" ? (
          <DeleteFuhrparkeintragNewButton remove={remove} index={index} />
        ) : (
          <DeleteFuhrparkeintragButton
            remove={remove}
            index={index}
            id={fuhrparkeintrag.id}
            taetigkeitsberichtId={taetigkeitsberichtId}
          />
        )}
      </AccordionSummary>
      {expanded && (
        <AccordionDetails sx={{ p: 0 }}>
          <FuhrparkeintragFieldsContent
            isNew={isNew}
            index={index}
            fahrzeugHerkunft={"EIGEN_GERAET"}
            taetigkeitsberichtDatum={taetigkeitsberichtDatum}
            dauerVorhanden={dauerVorhanden}
            isValidating={isValidating}
            isValid={isValid}
            isFremdleistung={false}
            fuhrparkeintrag={fuhrparkeintrag}
            taetigkeitsberichtBaustelleId={taetigkeitsberichtBaustelleId}
          />
        </AccordionDetails>
      )}
    </Accordion>
  );
}
